import Sort from "@/api/query/sorts/sort";

/**
 * Группы сортировки
 */
export default class SortGroup {
    constructor(sorts) {
        this.sorts = [];

        for (const sort of sorts) {
            this.addSort(sort);
        }
    }

    addSort(sort) {
        if (!(sort instanceof Sort)) {
            throw TypeError("sort must be instance of Sort");
        }

        this.sorts.push(sort);
    }

    getSorts() {
        return this.sorts;
    }
}
